export class InvalidTokenError extends Error {
  constructor(message: string) {
    super(message); // (1)
    this.name = "InvalidTokenError"; // (2)
  }
}